import { GroupBase, PlaceholderProps, components } from 'react-select'

import styles from './Placeholder.module.scss'

export const Placeholder = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: PlaceholderProps<Option, IsMulti, Group>
) => <components.Placeholder {...props} className={styles.root} />
